const healing = (key, name, count, modifier) => Object.freeze({ key, name, kind: 'healing', dice: { count, sides: 4 }, modifier, resource: 'bonusAction' });
export const POTION_DEFINITIONS = Object.freeze({
  'potion-healing': healing('potion-healing', 'Potion of healing', 2, 2),
  'potion-healing-greater': healing('potion-healing-greater', 'Potion of healing (greater)', 4, 4),
  'potion-healing-superior': healing('potion-healing-superior', 'Potion of healing (superior)', 8, 8),
  'potion-healing-supreme': healing('potion-healing-supreme', 'Potion of healing (supreme)', 10, 20),
  // Goodberry (the spell): 1 Hit Point, with nothing to roll.
  goodberry: healing('goodberry', 'Goodberry', 0, 1),
  'potion-invisibility': Object.freeze({ key: 'potion-invisibility', name: 'Potion of invisibility', kind: 'invisible', resource: 'bonusAction' }),
});
const normalize = value => String(value || '').trim().toLowerCase();
export const potionDefinition = value => Object.values(POTION_DEFINITIONS).find(definition =>
  [definition.key, normalize(definition.name)].includes(normalize(value))) || null;
export const potionForItem = item => [typeof item === 'string' ? item : item?.itemKey, item?.name, item?.displayName, item?.index]
  .map(potionDefinition).find(Boolean) || null;
export const ownedPotionCount = (items, key) => (Array.isArray(items) ? items : []).filter(item => potionForItem(item)?.key === key).length;
